module.exports = __webpack_public_path__ + "img/icon_service_03.c6154f22.png";